import '../modules/WebSdk'
import React, { Component } from 'react';
import { FingerprintReader, SampleFormat, QualityCode, SamplesAcquired } from '@digitalpersona/devices';



export default class FingerprintReaderControl {
    reader: FingerprintReader | undefined;
    samplesAcquired = (sample: SamplesAcquired) => { };
    acquisitionStarted = () => {};
    acquisitionStopped = () => {};

    constructor() {
        this.reader = new FingerprintReader();
        this.samplesAcquired = this.samplesAcquired.bind(this)
        this.acquisitionStarted = this.acquisitionStarted.bind(this)
        this.acquisitionStopped = this.acquisitionStopped.bind(this)
    }

    isReaderConnected: boolean = false;

    cleanup() {
        if (this.reader != undefined) {
            this.reader.stopAcquisition();
            this.reader.off();
            delete this.reader;
        }
    }

    async stopAcquiring() {
        this.reader?.stopAcquisition();
    }

    async startAcquiring() {
        if (this.reader != undefined) {
            try {
                await this.reader.startAcquisition(SampleFormat.Intermediate);
            } catch (err) {
            }
            try {
                this.reader.onAcquisitionStarted = async (device) => {
                    this.acquisitionStarted();
                };
                this.reader.onAcquisitionStopped = async (device) => {
                    this.acquisitionStopped();
                };
                this.reader.onDeviceConnected = async (device) => {
                    await this.updateReaderStatus();
                };
                this.reader.onDeviceDisconnected = async (device) => {
                    await this.updateReaderStatus();
                };
                this.reader.onSamplesAcquired = (sample) => {
                    this.samplesAcquired(sample);
                };
                this.reader.onErrorOccurred = (reason) => {
                    console.log("Error")
                    console.log(reason)
                };
            } catch (err) {
                console.log(err)
            }
        }
    }

    async updateReaderStatus() {
        if (this.reader != null) {
            try {
                const devices = await this.reader.enumerateDevices();
                this.isReaderConnected = devices.length > 0;
            } catch (err) {
                this.isReaderConnected = false;
                console.log("Error")
                console.log(err)
            }
        }
    }
    

}

function b64UrlTob64(n: string){
    return n.length%4==2?n=n+"==":n.length%4==3&&(n=n+"="),n=n.replace(/-/g,"+"),n.replace(/_/g,"/")
}

export {b64UrlTob64};